import { createAction } from "@reduxjs/toolkit";

export const showPwaBanner = createAction(
  "lwc/globalBannerConfigs/showPwaBanner"
);

export const hidePwaBanner = createAction(
  "lwc/globalBannerConfigs/hidePwaBanner"
);
